import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message"]

  connect() {
    this.messageTargets.forEach(msg => this.setupMessage(msg))
  }

  messageTargetConnected(msg) {
    this.setupMessage(msg)
  }

  setupMessage(msg) {
    if (msg.querySelector('.notice__close')) return
    
    const btn = document.createElement('button')
    btn.type = 'button'
    btn.className = 'notice__close'
    btn.setAttribute('aria-label', 'Cerrar mensaje')
    btn.innerHTML = '&times;'
    
    btn.addEventListener('click', (e) => {
      e.preventDefault()
      this.dismiss(msg)
    })

    msg.appendChild(btn)

    msg.addEventListener('click', (e) => {
      if (e.target.closest('a, button, input, textarea, select, label, .notice__close')) return
      e.preventDefault()
      this.dismiss(msg)
    })
  }

  dismiss(msg) {
    const slug = msg.getAttribute('data-slug') || null
    msg.style.transition = 'opacity 200ms ease, height 200ms ease, margin 200ms ease, padding 200ms ease'
    msg.style.opacity = '0'
    msg.style.height = '0'
    msg.style.margin = '0'
    msg.style.padding = '0'
    setTimeout(() => {
      if (msg && msg.parentNode) msg.parentNode.removeChild(msg)
      this.dispatch('dismiss', { detail: { slug } })
    }, 220)
  }
}
